var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mb-10",attrs:{"show":"","dismissible":"","variant":"light"}},[_c('p',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }